import { types } from 'mobx-state-tree';

import { Address } from '../definitions/Common';
import {
    PropertyPurposeValues,
    PropertyTypeValues,
    HowManyMortgagesValues,
    YearsAtMostRecentAddressValues,
    OccupyingValues,
} from '../definitions/InsCommon';


export default types
    .model('PropertyModel', {
        // Set to maybe instead of maybeNull as the address
        // component throws error when null
        insuredAddress: types.maybeNull(Address),

        propertyPurpose: types.maybeNull(types.enumeration(Object.values(PropertyPurposeValues))),
        propertyType: types.maybeNull(types.enumeration(Object.values(PropertyTypeValues))),
        howManyMortgages: types.maybeNull(types.enumeration(Object.values(HowManyMortgagesValues))),
        yearsAtMostRecentAddress: types.maybeNull(types.enumeration(Object.values(YearsAtMostRecentAddressValues))),
        occupying: types.maybeNull(types.enumeration(Object.values(OccupyingValues))),
    })
    .views(self => ({
        get isComplete() {
            return (
                self.insuredAddress !== null
                && self.propertyPurpose !== null
                && self.propertyType !== null
                && self.howManyMortgages !== null
                && self.yearsAtMostRecentAddress !== null
                && self.occupying !== null
            );
        },
    }));
